import { useQuery } from '@tanstack/react-query';
import { useNavigate, useSearchParams } from 'react-router';
import { CRM_PERSONAS, type CrmPerson } from '@aviaconsole/shared';
import { capi } from '../../api/client';
import { useAuth } from '../../auth/AuthProvider';
import { useI18n } from '../../i18n';
import { formatDate } from '../../lib/format';
import { Card, Chip, Empty, Input, Loading, PageHeader, Select } from '../../components/ui';
import { crmLabel, crmOptions } from '../../lib/crm';

export function CrmPeople() {
  const { company } = useAuth();
  const { t, lang } = useI18n();
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const filter = (k: string) => params.get(k) ?? '';
  const setFilter = (k: string, v: string) => { const n = new URLSearchParams(params); if (v) n.set(k, v); else n.delete(k); setParams(n, { replace: true }); };
  const qs = new URLSearchParams({ limit: '500' });
  for (const k of ['q', 'persona', 'optedOut']) if (filter(k)) qs.set(k, filter(k));
  const people = useQuery({ queryKey: ['crm-people', company?.id, qs.toString()], queryFn: () => capi<CrmPerson[]>(`/crm/people?${qs}`) });
  return (
    <>
      <PageHeader crumb={t('crmCrumb')} title={t('peopleTitle')} sub={t('peopleSub')} />
      <div className="stack">
        <Card>
          <div className="filters">
            <Input label={t('filterSearch')} value={filter('q')} onChange={(e) => setFilter('q', e.target.value)} />
            <Select label={t('colPersona')} options={crmOptions('persona', CRM_PERSONAS, lang, t('filterAll'))} value={filter('persona')} onChange={(e) => setFilter('persona', e.target.value)} />
            <Select label={t('colOptOut')} options={[{ value: '', label: t('filterAll') }, { value: 'false', label: t('filterOutreach') }, { value: 'true', label: t('filterOptedOut') }]} value={filter('optedOut')} onChange={(e) => setFilter('optedOut', e.target.value)} />
          </div>
        </Card>
        <Card pad={false} className="table">
          {!people.data ? <Loading error={people.error} /> : (
            <table>
              <thead><tr><th>{t('colName')}</th><th>{t('colAccount')}</th><th>{t('colPersona')}</th><th>{t('colBasis')}</th><th>{t('colSourceShort')}</th><th>{t('colOptOut')}</th></tr></thead>
              <tbody>
                {people.data.length === 0 && <Empty />}
                {people.data.map((p) => (
                  <tr key={p.id} className="click" onClick={() => navigate(`/crm/accounts/${p.accountId}`)}>
                    <td><div style={{ fontWeight: 600 }}>{p.name}</div><div className="sub">{p.email ?? p.roleTitle ?? ''}</div></td>
                    <td>{p.accountName}</td>
                    <td className="secondary small">{crmLabel('persona', p.persona, lang)}</td>
                    <td className="secondary small">{crmLabel('basis', p.lawfulBasis, lang)}</td>
                    <td className="secondary small" style={{ maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={p.source}>{p.source}</td>
                    <td>{p.optedOutAt ? <Chip tone="danger" icon="fas fa-ban">{formatDate(p.optedOutAt, lang)}</Chip> : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Card>
      </div>
    </>
  );
}
